import { Validator } from 'vee-validate';
import en from 'vee-validate/dist/locale/en';
import da from 'vee-validate/dist/locale/da';

function setEnLocale(isEnglish) {
    if(isEnglish) {
        Validator.localize("en", en);
    } else {
        Validator.localize("da", da);
    }    
}

export default setEnLocale;
